
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_gj09l_145",
  "breadcrumb": "awsui_breadcrumb_1kosq_gj09l_149",
  "ghost-breadcrumb": "awsui_ghost-breadcrumb_1kosq_gj09l_150",
  "icon": "awsui_icon_1kosq_gj09l_153",
  "anchor": "awsui_anchor_1kosq_gj09l_159",
  "text": "awsui_text_1kosq_gj09l_206",
  "last": "awsui_last_1kosq_gj09l_225"
};
  